(ns iris.views
  {:shadow.css/include ["iris/styles/global.css"]}
  (:require
   ["react" :as react]
   [re-frame.core :as re-frame]
   [reagent.core :as r]
   [iris.events :as events]
   [iris.routes :as routes]
   [iris.route-scroll :as route-scroll]
   [iris.subs :as subs]
   [iris.common :as common]
   [iris.side-panel.views :as side-panel]
  ;;  [iris.screens.views :as screens-views]
  ;;  [iris.censors.views :as censors-views]
  ;;  [iris.posts.views :as posts-views]
  ;;  [iris.twbot.views :as twbot-views]
  ;;  [iris.analytics.views :as analytics-views]
  ;;  [iris.search.views :as search-views]
   [iris.login.views :as login-views]
   [iris.login.subs :as login-subs]
   [iris.error.views :as error-views]
   [iris.globals :as globals]

   [iris.lazyload :refer (lazy-component)]))


(defn startup-loading-panel
  "Full-page startup/loading view.

  This component is intentionally independent of app-db loading state. `:loading`
  is used by pages and RPC flows after the app shell is already running; this
  panel covers app/bootstrap states where Iris cannot render the intended route
  yet. The same markup also exists in the HTML entrypoints so users see feedback
  before React mounts."
  []
  [:div.iris-startup-loading
   {:style {:align-items "center"
            :background "var(--iris-bg)"
            :color "var(--iris-text)"
            :display "flex"
            :flex-direction "column"
            :font-family "Open Sans, Arial, sans-serif"
            :gap "14px"
            :justify-content "center"
            :min-height "100dvh"}}
   [:div.spinloader
    {:aria-hidden "true"
     :style {:margin 0
             :position "static"}}]
   [:div
    {:style {:font-size "16px"
             :font-weight 600}}
    "Loading Iris..."]])


(defn route-panel
  "Render an already-selected route panel behind a React Suspense boundary.

  Use this only after `main-panel` has enough app state to render a route:
  active route is known, auth is acceptable for app routes, workspace sync is
  complete, and no default-workspace redirect is pending. The loading panel here
  is only the fallback for lazy-loaded route chunks.

  When app/router/auth/workspace state itself is not ready, render
  `startup-loading-panel` directly from `main-panel` instead."
  [active-panel]
  (r/after-render route-scroll/after-render!)
  [:> react/Suspense
   {:fallback (r/as-element [startup-loading-panel])}
   (routes/panels active-panel)])


;; (defmethod routes/panels :screens-panel [] [screens-views/screens-panel])

;; (defmethod routes/panels :screens-create-new-panel [] [screens-views/screens-create-new-panel])

;; (defmethod routes/panels :screens-edit-panel [] [screens-views/screens-edit-panel])


;; (defmethod routes/panels :censors-create-new-panel [] [censors-views/censors-create-new-panel])

;; (defmethod routes/panels :censors-panel [] [censors-views/censors-panel])

;; (defmethod routes/panels :censors-edit-panel [] [censors-views/censors-edit-panel])


;; (defmethod routes/panels :user-panel [] [posts-views/user-panel])

;; (defmethod routes/panels :thread-panel [] [posts-views/thread-panel])

;; (defmethod routes/panels :posts-header-panel [] [posts-views/posts-header-panel])

;; (defmethod routes/panels :hashtag-panel [] [posts-views/hashtag-panel])

;; (defmethod routes/panels :posts-ip-panel [] [posts-views/posts-ip-panel])
;; (defmethod routes/panels :posts-eid-panel [] [posts-views/posts-eid-panel])
;; (defmethod routes/panels :posts-cc-panel [] [posts-views/posts-cc-panel])
;; (defmethod routes/panels :posts-panel [] [posts-views/posts-panel])

;; (defmethod routes/panels :twbot-panel [] [twbot-views/twbot-panel])

;; (defmethod routes/panels :analytics-panel [] [analytics-views/analytics-panel])

;; (defmethod routes/panels :search-panel [] [search-views/search-panel])
;; (defmethod routes/panels :search-panel [] [posts-views/search-panel])

;; KEEPING LOGIN BECAUSE WE DIDN'T TURN IT INTO LAZY LOADED MODULE:
(defmethod routes/panels :login-panel [] [login-views/login-panel])

(defmethod routes/panels :error-panel [] [error-views/error-panel])

(def homepage-panel (lazy-component iris.homepage.views/homepage-panel))

;; (def search (lazy-component iris.search.views/search-panel))
(def search (lazy-component iris.posts.views/search-panel))
(def header-search (lazy-component iris.search.views/header-search-panel))

(def screens (lazy-component iris.screens.views/screens-panel))
(def screens-create (lazy-component iris.screens.views/screens-create-new-panel))
(def screens-edit (lazy-component iris.screens.views/screens-edit-panel))

(def censors (lazy-component iris.censors.views/censors-panel))
(def censors-create (lazy-component iris.censors.views/censors-create-new-panel))
(def censors-edit (lazy-component iris.censors.views/censors-edit-panel))

(def user-panel (lazy-component iris.posts.views/user-panel))
(def thread-panel (lazy-component iris.posts.views/thread-panel))
(def posts-header-panel (lazy-component iris.posts.views/posts-header-panel))
(def hashtag-panel (lazy-component iris.posts.views/hashtag-panel))
(def posts-ip-panel (lazy-component iris.posts.views/posts-ip-panel))
(def posts-eid-panel (lazy-component iris.posts.views/posts-eid-panel))
(def posts-cc-panel (lazy-component iris.posts.views/posts-cc-panel))
(def posts-panel (lazy-component iris.posts.views/posts-panel))

(def analytics-panel (lazy-component iris.analytics.views/analytics-panel))
(def analytics-page-views-panel (lazy-component iris.analytics.views/analytics-page-views-panel))

(def tags-panel (lazy-component iris.tags.views/tags-panel))
(def tags-pending-panel (lazy-component iris.tags.views/tags-pending-panel))
(def tags-approved-panel (lazy-component iris.tags.views/tags-approved-panel))
(def tags-removed-panel (lazy-component iris.tags.views/tags-removed-panel))
(def tags-blocked-panel (lazy-component iris.tags.views/tags-blocked-panel))

(def sessions-panel (lazy-component iris.sessions.views/sessions-panel))

(def logs-panel (lazy-component iris.logs.views/logs-panel))
(def logs-header-panel (lazy-component iris.logs.views/logs-header-panel))
(def logs-post-panel (lazy-component iris.logs.views/logs-post-panel))
(def logs-thread-panel (lazy-component iris.logs.views/logs-thread-panel))
(def logs-ip-panel (lazy-component iris.logs.views/logs-ip-panel))
(def logs-eid-panel (lazy-component iris.logs.views/logs-eid-panel))
(def logs-user-panel (lazy-component iris.logs.views/logs-user-panel))
(def logs-header-create-panel (lazy-component iris.logs.views/logs-header-create-panel))
(def logs-chosen-header-create-panel (lazy-component iris.logs.views/logs-chosen-header-create-panel))
(def logs-chosen-header-edit-panel (lazy-component iris.logs.views/logs-chosen-header-edit-panel))
(def logs-search-panel (lazy-component iris.logs.views/logs-search-panel))
(def dev-panel (lazy-component iris.dev.views/dev-panel))

(def latest-panel (lazy-component iris.posts.views/latest-panel))


(defmethod routes/panels :homepage-panel [] [:> homepage-panel])

(defmethod routes/panels :search-panel [] [:> search])
(defmethod routes/panels :header-search-panel [] [:> header-search])

(defmethod routes/panels :screens-panel [] [:> screens])
(defmethod routes/panels :screens-create-new-panel [] [:> screens-create])
(defmethod routes/panels :screens-edit-panel [] [:> screens-edit])

(defmethod routes/panels :censors-panel [] [:> censors])
(defmethod routes/panels :censors-create-new-panel [] [:> censors-create])
(defmethod routes/panels :censors-edit-panel [] [:> censors-edit])

(defmethod routes/panels :user-panel [] [:> user-panel])
(defmethod routes/panels :thread-panel [] [:> thread-panel])
(defmethod routes/panels :posts-header-panel [] [:> posts-header-panel])
(defmethod routes/panels :hashtag-panel [] [:> hashtag-panel])
(defmethod routes/panels :posts-ip-panel [] [:> posts-ip-panel])
(defmethod routes/panels :posts-eid-panel [] [:> posts-eid-panel])
(defmethod routes/panels :posts-cc-panel [] [:> posts-cc-panel])
(defmethod routes/panels :posts-panel [] [:> posts-panel])

(defmethod routes/panels :analytics-panel [] [:> analytics-panel])
(defmethod routes/panels :analytics-page-views-panel [] [:> analytics-page-views-panel])

(defmethod routes/panels :tags-panel [] [:> tags-panel])
(defmethod routes/panels :tags-pending-panel [] [:> tags-pending-panel])
(defmethod routes/panels :tags-approved-panel [] [:> tags-approved-panel])
(defmethod routes/panels :tags-removed-panel [] [:> tags-removed-panel])
(defmethod routes/panels :tags-blocked-panel [] [:> tags-blocked-panel])

(defmethod routes/panels :sessions-panel [] [:> sessions-panel])

(defmethod routes/panels :logs-panel [] [:> logs-panel])
(defmethod routes/panels :logs-header-panel [] [:> logs-header-panel])
(defmethod routes/panels :logs-post-panel [] [:> logs-post-panel])
(defmethod routes/panels :logs-thread-panel [] [:> logs-thread-panel])
(defmethod routes/panels :logs-ip-panel [] [:> logs-ip-panel])
(defmethod routes/panels :logs-eid-panel [] [:> logs-eid-panel])
(defmethod routes/panels :logs-user-panel [] [:> logs-user-panel])
(defmethod routes/panels :logs-header-create-panel [] [:> logs-header-create-panel])
(defmethod routes/panels :logs-chosen-header-create-panel [] [:> logs-chosen-header-create-panel])
(defmethod routes/panels :logs-chosen-header-edit-panel [] [:> logs-chosen-header-edit-panel])
(defmethod routes/panels :logs-search-panel [] [:> logs-search-panel])
(defmethod routes/panels :dev-panel [] [:> dev-panel])

(defmethod routes/panels :latest-panel [] [:> latest-panel])







(defn default-ws-redirect [ws active-panel panel param route]
  (when (= active-panel panel)
    (let [route-params (re-frame/subscribe [::subs/route-params])
          ruid (param @route-params)]
      (when (and ruid (nil? (re-find #"^.+\.[A-Z]{3}$" ruid)))
        (re-frame/dispatch [::events/route-to-replace (str "/" route ruid "." ws)])
        true)))) ;; return true if redirected


(defn login-panel? [active-panel]
  (= active-panel :login-panel))

(defn redirect-default-ws-if-needed [ws active-panel]
  (or (default-ws-redirect ws active-panel :posts-header-panel :header "")
      (default-ws-redirect ws active-panel :hashtag-panel :tag "h/")))


(defn redirect-to-login-and-show-loading []
  (let [l (.. js/window -location)
        p (str l.pathname l.search l.hash)]
    (reset! globals/login_redirect p)
    (re-frame/dispatch [::events/navigate :login])
    [startup-loading-panel]))

(defn app-shell [active-panel]
  (let [theme @(re-frame/subscribe [::subs/theme])
        dark-theme-depth @(re-frame/subscribe [::subs/dark-theme-depth])
        dark? (= theme :dark)]
    [:div
     {:class "iris-app-shell"}
     [common/admin-top-bar]
     [:div
      {:class (str "iris-themed-content"
                   (when dark? " iris-theme-dark")
                   (when (and dark? (not= dark-theme-depth 0))
                     (str " iris-dark-depth-" dark-theme-depth)))}
      [common/navbar]
      [side-panel/side-panel]
      [common/spinner]
      [route-panel active-panel]
      [common/message ::subs/message]]]))

;; Root app decision tree.
;;
;; `main-panel` decides whether Iris is ready to render an actual route. If not,
;; it returns `startup-loading-panel` directly so React never renders nil during
;; boot/navigation/auth/workspace setup.
;;
;; Once the app is ready to render the selected route, it delegates to
;; `route-panel`, which adds the Suspense boundary needed by React.lazy route
;; components. In short:
;;
;;   [startup-loading-panel]   => app cannot safely choose/render a route yet
;;   [route-panel active-panel] => app is ready; lazy route chunk may still load
(defn main-panel []
  (let [active-panel (re-frame/subscribe [::subs/active-panel])
        ws-sync      (re-frame/subscribe [::subs/ws-sync])
        ws           (re-frame/subscribe [::subs/ws])
        logged-in?   (re-frame/subscribe [::login-subs/logged-in?])]
    (cond
      ;; Login is bundled eagerly, so it does not need the lazy-route Suspense
      ;; boundary. It must also be reachable without workspace sync.
      (login-panel? @active-panel)
      (routes/panels :login-panel)

      ;; The router has not published a route panel yet. There is no route
      ;; component to render, so show the app-level startup state directly.
      (nil? @active-panel)
      [startup-loading-panel]

      ;; Not authenticated for app routes. Preserve the requested URL for login
      ;; redirect, start navigation to login, and show startup state until the
      ;; login route renders.
      (not @logged-in?)
      (redirect-to-login-and-show-loading)

      ;; Logged-in routes depend on the default workspace being synced. Until
      ;; then, route panels can derive incomplete URLs/state.
      (not @ws-sync)
      (do
        (println "Still syncing ws...")
        [startup-loading-panel])

      ;; Auth and workspace state are ready. We may still need to normalize
      ;; legacy/default-workspace URLs before rendering the route.
      (redirect-default-ws-if-needed @ws @active-panel)
      (do
        (println "Redirected, showing startup loading panel while route settles.")
        [startup-loading-panel])

      ;; The selected route is safe to render. `route-panel` handles only lazy
      ;; chunk loading from this point on.
      :else
      [app-shell @active-panel])))
